import React from 'react'

const MentionDropdown = ({ members = [], selectedIndex = 0, onSelect, onHover, className = '' }) => {
  if (!Array.isArray(members) || members.length === 0) return null

  const getInitial = (firstName) => (firstName || '').trim().charAt(0).toUpperCase() || ''

  const rootClassName = ['mention-dropdown', className].filter(Boolean).join(' ')

  return (
    <div className={rootClassName}>
      {members.map((member, index) => {
        if (member.isEveryone) {
          return (
            <div key="everyone" className={`mention-item ${index === selectedIndex ? 'selected' : ''}`} onClick={() => onSelect && onSelect(member)} onMouseEnter={() => onHover && onHover(index)}>
              <div className="mention-avatar">E</div>
              <div className="mention-item-name">Everyone</div>
            </div>
          )
        }

        const firstName = member.first_name || ''
        const lastName = member.last_name || ''
        const fullName = `${firstName} ${lastName}`.trim() || 'User'
        const initials = getInitial(firstName)

        return (
          <div key={member.userid || member.id || index} className={`mention-item ${index === selectedIndex ? 'selected' : ''}`} onClick={() => onSelect && onSelect(member)} onMouseEnter={() => onHover && onHover(index)}>
            <div className="mention-avatar">{initials}</div>
            <div className="mention-item-name">{fullName}</div>
          </div>
        )
      })}
    </div>
  )
}

export default MentionDropdown
